import AppIcon from '../../../components/AppIcon';

const DeliveryLogs = ({ logs, statusFilter, setStatusFilter }) => {
  const formatTime = (dateString) => {
    const date = new Date(dateString);
    return date?.toLocaleString('ar-SA', {
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  const getStatusConfig = (status) => {
    const configs = {
      delivered: {
        label: 'تم التسليم',
        icon: 'CheckCircle',
        color: 'var(--color-success)',
        bgColor: 'bg-success/10',
        textColor: 'text-success'
      },
      failed: {
        label: 'فشل',
        icon: 'XCircle',
        color: 'var(--color-error)',
        bgColor: 'bg-error/10',
        textColor: 'text-error'
      },
      bounced: {
        label: 'مرتد',
        icon: 'AlertCircle',
        color: 'var(--color-warning)',
        bgColor: 'bg-warning/10',
        textColor: 'text-warning'
      }
    };
    return configs?.[status] || configs?.delivered;
  };

  const statusOptions = [
    { value: 'all', label: 'الكل' },
    { value: 'delivered', label: 'تم التسليم' },
    { value: 'failed', label: 'فشل' },
    { value: 'bounced', label: 'مرتد' }
  ];

  const filteredLogs = statusFilter === 'all' 
    ? logs 
    : logs?.filter(log => log?.status === statusFilter);

  return (
    <div className="bg-card rounded-lg border border-border overflow-hidden">
      <div className="p-6 border-b border-border">
        <div className="flex items-center justify-between mb-4">
          <div>
            <h2 className="text-xl font-bold text-foreground">سجلات التسليم</h2>
            <p className="text-sm text-muted-foreground mt-1">تتبع حالة الإيميلات المرسلة</p>
          </div>
          <AppIcon name="FileText" size={24} className="text-primary" />
        </div>

        {/* Status Filter */}
        <div className="flex gap-2">
          {statusOptions?.map(option => (
            <button
              key={option?.value}
              onClick={() => setStatusFilter(option?.value)}
              className={`px-3 py-1.5 rounded-lg text-xs font-medium transition-colors ${
                statusFilter === option?.value
                  ? 'bg-primary text-primary-foreground'
                  : 'bg-muted text-muted-foreground hover:bg-muted/80'
              }`}
            >
              {option?.label}
            </button>
          ))}
        </div>
      </div>

      <div className="divide-y divide-border max-h-[600px] overflow-y-auto">
        {filteredLogs?.map(log => {
          const statusConfig = getStatusConfig(log?.status);

          return (
            <div key={log?.id} className="p-4 hover:bg-muted/30 transition-colors">
              <div className="flex items-start justify-between mb-3">
                <div className="flex-1">
                  <div className="flex items-center gap-2 mb-1">
                    <h3 className="font-semibold text-foreground text-sm">{log?.recipient}</h3>
                  </div>
                  <p className="text-xs text-muted-foreground">{log?.email}</p>
                </div>
                <span className={`px-2 py-1 rounded-full text-xs font-medium flex items-center gap-1 ${statusConfig?.bgColor} ${statusConfig?.textColor}`}>
                  <AppIcon name={statusConfig?.icon} size={12} />
                  {statusConfig?.label}
                </span>
              </div>

              <div className="mb-2">
                <p className="text-sm text-foreground">{log?.template}</p>
              </div>

              {log?.status === 'failed' && log?.error && (
                <div className="mb-2 p-2 bg-error/10 rounded text-xs text-error flex items-start gap-2">
                  <AppIcon name="AlertCircle" size={14} className="mt-0.5" />
                  <span>{log?.error}</span>
                </div>
              )}

              <div className="flex items-center gap-4 text-xs text-muted-foreground">
                <div className="flex items-center gap-1">
                  <AppIcon name="Send" size={12} />
                  <span>أُرسل: {formatTime(log?.sentTime)}</span>
                </div>
                {log?.openedAt && (
                  <div className="flex items-center gap-1">
                    <AppIcon name="Eye" size={12} />
                    <span>فُتح: {formatTime(log?.openedAt)}</span>
                  </div>
                )}
                {log?.clickedAt && (
                  <div className="flex items-center gap-1">
                    <AppIcon name="MousePointer" size={12} />
                    <span>نُقر: {formatTime(log?.clickedAt)}</span>
                  </div>
                )}
              </div>
            </div>
          );
        })}
      </div>

      {filteredLogs?.length === 0 && (
        <div className="p-8 text-center">
          <AppIcon name="Inbox" size={48} className="mx-auto text-muted-foreground mb-3" />
          <p className="text-muted-foreground">لا توجد سجلات مطابقة</p>
        </div>
      )}
    </div>
  );
};

export default DeliveryLogs;